import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShowBase, Title, Button } from 'react-admin';
import { Card, CardContent, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import BomChart from "../../components/BomChart.tsx"; // BomChart 组件来显示图表

export default function BomChartPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [chartData, setChartData] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';
  const [rawMaterialData, setRawMaterialData] = useState([]);
  const [packagingMaterialData, setPackagingMaterialData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    fetch(`${API_URL}/bom/${id}/items`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => {// 处理每项，取 material.name 作为 name 字段
        const processedData = (data ?? []).map(item => ({
          ...item,
          name: item.material ? `${item.material.productId} - ${item.material.name} (${item.quantity}${item.material.unit || ''})`
            : '', // 关键处理

        }));
        setRawMaterialData(processedData.filter(item => item.material?.type === 'RawMaterial'));
        setPackagingMaterialData(
          processedData
            .filter(item => item.material?.type === 'PackagingMaterial')
            .map(item => ({
              ...item,
              name: item.material
                ? `${item.material.productId} - ${item.material.name} (${item.quantity}${item.material.unit || ''})`
                : '',
            }))
        );
      });
  }, [id, API_URL]);

  return (
    <ShowBase resource="bom" id={id}>
      <Card sx={{ margin: 4, borderRadius: 2, boxShadow: 3, minHeight: '500px' }}>
        {/* 顶部按钮区 */}
        <Stack direction="row" spacing={2} sx={{ mb: 2, margin: 2 }}>
          <Button
            label="List"
            onClick={() => navigate('/bom')}
            startIcon={<ArrowBackIcon />}
          />
          <Button
            label="edit"
            onClick={() => navigate(`/bom/${id}`)}
            startIcon={<EditIcon />}
            color="primary"
          />
        </Stack>
        <Title title="BOM RawMaterial and PackagingMaterial" />
        <CardContent>
          <div style={{ marginBottom: 32 }}>
            <h3>RawMaterial</h3>
            <BomChart data={rawMaterialData} type="RawMaterial" />
          </div>
          <div>
            <h3>PackagingMaterial</h3>
            <BomChart data={packagingMaterialData} type="PackagingMaterial" />
          </div>
        </CardContent>
      </Card>
    </ShowBase>
  );
}
